import { ListFilterCustomSelect } from "../../components/ListFilterCustomSelect";
import { OFFER_STATUS_FILTERS } from "../../utils/listFilterQuery";
import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";

type Props = {
  searchTerm: string;
  statusFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
};

export function OffersListFilters({
  searchTerm,
  statusFilter,
  onSearchChange,
  onStatusChange,
}: Props) {
  return (
    <div className="mb-6 mt-4 flex w-full flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
      <label className="flex min-w-0 flex-1 flex-col gap-1 text-left text-xs font-medium text-slate-600 md:max-w-md">
        Busca
        <input
          className={`${FLOW_TEXT_INPUT_BASE} !font-[inherit]`}
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Buscar por cliente, e-mail ou código do imóvel..."
        />
      </label>

      <ListFilterCustomSelect
        label="Status"
        value={statusFilter}
        options={OFFER_STATUS_FILTERS}
        onChange={onStatusChange}
      />
    </div>
  );
}
